import { createInstance } from '@datapunt/matomo-tracker-react'
export const instance = createInstance({
  urlBase: process.env.REACT_APP_URL_BASE,
  siteId: 2,
})